export const getUiCheckboxFieldTemplate = (options) => {
  const {
    size = 'small',
    fieldAttrs = '',
    fieldText = '',
    fieldName = '',
    classes = '',
    isVisualDisabled = false
  } = options

  return `
    <label class="
        ui-checkbox-field
        ${size === 'small' ? 'f f--14' : 'f f--16'}
        ${classes}
      "
    >
      <input
        class="
          ui-checkbox-field__input sr-only
          ${isVisualDisabled ? 'ui-checkbox-field__input--v-disabled' : ''}
        "
        name="${fieldName}"
        type="checkbox"
        ${fieldAttrs}
      >
      <span
        class="
          ui-checkbox-field__value
          ui-checkbox-field__value--${size}
          ${!fieldText ? 'ui-checkbox-field__input--single' : ''}
        "
      >
        <svg
          class="
            ui-checkbox-field__icon
            ui-checkbox-field__icon--${size}
          "
          width="16"
          height="12"
          aria-hidden="true"
        >
          <use href="#ui-done"></use>
        </svg>
  
        ${fieldText}
      </span>
    </label>
  `
}
